import { CommonModule } from '@angular/common';
import { Component, inject, signal, WritableSignal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { ErrorSnackbar } from '../../components/snackbar/error-snackbar/error-snackbar';
import { SuccessSnackbar } from '../../components/snackbar/success-snackbar/success-snackbar';
import { Country, CountryDialog, paises } from '../../dialogs/country-dialog/country-dialog';
import { AuthService, LoginTelefoneNascimentoRequest } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  imports: [
    FormsModule,
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatGridListModule,
    MatSelectModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatIconModule,
    MatTableModule,
    NgxMaskDirective,
  ],
  templateUrl: './login.html',
  styleUrl: './login.scss',
  providers: [provideNgxMask()],
})
export class Login {
  pais = '';
  telefoneCelular = '';
  nascimento = '';
  politicaPrivacidade = false;

  country: WritableSignal<Country | null> = signal(null);
  mascaraTelefone = signal('');
  errorMessage = signal('');
  _snackBar = inject(MatSnackBar);

  constructor(
    public dialog: MatDialog,
    private authService: AuthService,
    private router: Router
  ) {
    this.mascaraTelefone.set(paises[0].mask);
  }

  onCountryClick(event: MouseEvent) {
    event.preventDefault();
    event.stopImmediatePropagation();

    this.openCountryDialog();
  }

  onCountrySelected(country: Country) {
    this.country.set(country);
    this.mascaraTelefone.set(country.mask);
    this.pais = `${country.flag} +${country.ddi}`;
  }

  openCountryDialog() {
    const dialogRef = this.dialog.open(CountryDialog, {
      width: '300px',
      height: '600px',
      data: { currentCountry: this.country() },
    });

    dialogRef.afterClosed().subscribe((result: Country) => {
      if (result) {
        this.onCountrySelected(result);
      }
    });
  }

  togglePrivacyPolicy() {
    this.politicaPrivacidade = !this.politicaPrivacidade;
  }

  abrirPoliticaDePrivacidade() {
    const fileName = 'Política de Privacidade - Portal.pdf';
    const pdfUrl = 'assets/docs/' + encodeURIComponent(fileName);
    window.open(pdfUrl, '_blank');
  }

  openSnackBar(kind: 'success' | 'error', msg: string) {
    if (kind === 'success') {
      this._snackBar.openFromComponent(SuccessSnackbar, {
        data: { message: msg },
        panelClass: ['success-snackbar'],
      });
    } else {
      this._snackBar.openFromComponent(ErrorSnackbar, {
        data: { message: msg },
        panelClass: ['error-snackbar'],
      });
    }
  }

  async onLogin() {
    if (this.politicaPrivacidade === false) {
      this.openSnackBar(
        'error',
        'Você precisa aceitar a política de privacidade'
      );
      return;
    }

    try {
      const dto: LoginTelefoneNascimentoRequest = {
        telefone: `+${this.country()?.ddi} ${this.telefoneCelular}`,
        dataNascimento: this.nascimento,
      };

      const token = await this.authService.loginComTelefoneDataNascimento(dto);
      this.authService.saveToken(token);
      this.router.navigate(['/chat']);
    } catch (error: any) {
      this.openSnackBar('error', error.message);
    }
  }
}
